// extracted by mini-css-extract-plugin
export default {"no-data-container":"DataTable_no-data-container__FLTRa"};